import { Injectable } from '@angular/core';
import { ModulePermissionControllerService } from '../../../projects/api-swagger-client/src/api/modulePermissionController.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService {
    constructor(
        public modulePermissionControllerService: ModulePermissionControllerService
    ) {}

    isAllowed = (path: string) => {
        return this.modulePermissionControllerService.modulePermissionControllerCheckPermissionsToAccessPath(
            { path: path }
        );
    };
}
